module.exports = __webpack_public_path__ + "img/notification-badge.6b329605.svg";